import React from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Binding from "../../../binding";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import Flex from "../../Misc/Flex";
import PropertyList from "../Property/PropertyList";
export default class ModelInfo extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      apply: [],
      products: [],
      model: {},
    };
  }
  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      this.load();
    }
  }

  load = async () => {
    const { id } = this.props;
    this.setState({ pending: true });
    let apply = await this.context.api.qa("/demand/element/list", {
      model: id,
    });
    let model = await this.context.api.q("/model/get", { id });
    let products = await this.context.api.qa("/product/list", {
      search: [
        {
          field: "model",
          value: id,
        },
      ],
    });
    this.setState({ pending: false, apply, products, model: model || {} });
  };

  render() {
    const { label, description, id } = this.props;
    const { pending, apply, products, model } = this.state;

    const Row = ({ label, value }) => {
      if (!value) return null;
      return (
        <div className="row">
          <div className="col-lg-6 my-2">{label}</div>
          <div className="col-lg my-2">{value}</div>
        </div>
      );
    };

    const binding = new Binding(model);

    return (
      <Modal size="lg" show onHide={this.props.onHide}>
        <Modal.Header closeButton>
          <Modal.Title className="w-100">
            <Flex between>
              <div>
                <div>{label}</div>
                {description && (
                  <div className="text-muted small">{description}</div>
                )}
              </div>
              <div>
                {binding.url && (
                  <Link to={binding.url} title="Перейти к ЗИП">
                    <i className="fa fa-share-square-o "></i>
                  </Link>
                )}
              </div>
            </Flex>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Blocker on={pending} hAuto>
            <div className="mb-5 pb-3">
              <Row label="Код" value={model.code} />
              <Row label="Специальный код" value={model.subcode} />
              <Row label="Категория" value={model.categoryname} />
              <Row label="Производитель" value={model.vendorname} />
              <Row label="Описание" value={model.description} />

              <PropertyList
                hidePending
                id={id}
                reference="model"
                referencekey="modelid"
              />
            </div>

            <div className="mt-5 pt-5 border-top">
              {apply?.length > 0 ? (
                <div>
                  <h4>Применяется к:</h4>
                  {apply.map((item, idx) => {
                    let line = item || {};
                    let datetime = line.operdate ? new Date(line.operdate) : {};
                    const binding = new Binding(line);
                    return (
                      <Row
                        key={idx}
                        label={<Link to={binding.url}>{binding.label}</Link>}
                        value={datetime.toLocaleString()}
                      />
                    );
                  })}
                </div>
              ) : (
                <div>
                  {!pending && (
                    <div className="text-muted">
                      Информация о применимости в запасных частях не найдена
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="mt-5 pt-5 border-top">
              {products?.length > 0 ? (
                <div>
                  <h4>Складские запасы:</h4>
                  {products.map((item, idx) => {
                    let line = item || {};
                    const binding = new Binding(line);
                    return (
                      <Row
                        key={idx}
                        label={<Link to={binding.url}>{line.storagename}</Link>}
                        value={
                          <span>
                            {line.balance}{" "}
                            <span className="text-muted">
                              {line.measurename}
                            </span>
                          </span>
                        }
                      />
                    );
                  })}
                </div>
              ) : (
                <div>
                  {!pending && (
                    <div className="text-muted">
                      Информация о наличии и судовых запасов отсутствует
                    </div>
                  )}
                </div>
              )}
            </div>
          </Blocker>
        </Modal.Body>
      </Modal>
    );
  }
}
